// Helpers for keeping PII out of logs, audit rows, and error-tracking payloads.

export function maskEmail(email: string | null | undefined): string {
  if (!email || typeof email !== "string") return "";
  const [local, domain] = email.split("@");
  if (!local || !domain) return "***";
  const head = local.length <= 2 ? local : local.substring(0, 2);
  return `${head}***@${domain}`;
}

const SENSITIVE_KEYS = new Set([
  "password",
  "token",
  "access_token",
  "refresh_token",
  "secret",
  "api_key",
  "authorization",
]);

export function sanitizeAuditData(input: unknown): unknown {
  if (input == null) return input;
  if (Array.isArray(input)) return input.map(sanitizeAuditData);
  if (typeof input !== "object") return input;
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(input as Record<string, unknown>)) {
    const lk = k.toLowerCase();
    if (SENSITIVE_KEYS.has(lk)) continue;
    if (lk === "email" && typeof v === "string") {
      out[k] = maskEmail(v);
      continue;
    }
    out[k] = typeof v === "object" ? sanitizeAuditData(v) : v;
  }
  return out;
}
